export const VERSION = '1.12.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map